function uniquePageWebsite() {
  // if (window.location.origin.includes("http://localhost:3000"))
  if (window.location.origin.includes("brbstoreonline.com"))
    return "654de7f357e212a6e2e63151"

  return false
}

export default uniquePageWebsite
